import { SyntheticEvent, useCallback, useEffect, useRef, useState } from 'react';

const IMAGE_PLACEHOLDER = 'https://image.bridebook.com/assets/image_placeholder.jpg';

export const useImageErrorHandling = (
  imgSrc: string,
  onError?: (e: SyntheticEvent<HTMLImageElement, Event>) => void,
) => {
  const [imageSrc, setImageSrc] = useState('');
  const [hasError, setHasError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const currentSrcRef = useRef('');

  useEffect(() => {
    if (imgSrc && imgSrc !== currentSrcRef.current) {
      currentSrcRef.current = imgSrc;
      setImageSrc(imgSrc);
      setHasError(false);
      setIsLoaded(false);
    }
  }, [imgSrc]);

  const handleError = useCallback(
    (e: SyntheticEvent<HTMLImageElement, Event>) => {
      const errorSrc = (e.target as HTMLImageElement).src;

      if (errorSrc === currentSrcRef.current && !hasError) {
        setHasError(true);
        setImageSrc(IMAGE_PLACEHOLDER);
        setIsLoaded(true); // Show placeholder immediately
      }

      onError?.(e);
    },
    [hasError, onError],
  );

  const handleLoad = useCallback(() => {
    setIsLoaded(true);
  }, []);

  return { imageSrc, hasError, isLoaded, handleError, handleLoad };
};
